import React, {useEffect, useState} from "react";
import {MAKE_VIEWER_SVS_URI, VIEWER_EKG_PAGE_URI} from "../../../../../../constants/uri.constant";
import ResultModel from "../../../../../../model/medicalCard/result.model";
import prettyBytes from "pretty-bytes";
import {useTranslation} from "react-i18next";
import {Tooltip} from 'antd'

const FileIcon = ({extension, imageLoad, ...props}) => {

    if(!['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png', 'svg', 'svs'].includes(extension)){
        return (
            <div {...props}>
                <svg onLoad={imageLoad} style={{width: 30}} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.0377 9.73154L18.5762 3.27C18.4904 3.18431 18.3885 3.11636 18.2765 3.07003C18.1644 3.0237 18.0443 2.9999 17.9231 3H6.84615C6.35652 3 5.88695 3.19451 5.54073 3.54073C5.1945 3.88695 5 4.35652 5 4.84615V25.1538C5 25.6435 5.1945 26.1131 5.54073 26.4593C5.88695 26.8055 6.35652 27 6.84615 27H23.4615C23.9512 27 24.4207 26.8055 24.767 26.4593C25.1132 26.1131 25.3077 25.6435 25.3077 25.1538V10.3846C25.3078 10.2634 25.284 10.1433 25.2377 10.0312C25.1913 9.91916 25.1234 9.81733 25.0377 9.73154ZM18.8462 6.15115L22.1565 9.46154H18.8462V6.15115ZM23.4615 25.1538H6.84615V4.84615H17V10.3846C17 10.6294 17.0973 10.8642 17.2704 11.0373C17.4435 11.2104 17.6783 11.3077 17.9231 11.3077H23.4615V25.1538ZM19.7692 15.9231C19.7692 16.1679 19.672 16.4027 19.4989 16.5758C19.3258 16.7489 19.091 16.8462 18.8462 16.8462H11.4615C11.2167 16.8462 10.9819 16.7489 10.8088 16.5758C10.6357 16.4027 10.5385 16.1679 10.5385 15.9231C10.5385 15.6783 10.6357 15.4435 10.8088 15.2704C10.9819 15.0973 11.2167 15 11.4615 15H18.8462C19.091 15 19.3258 15.0973 19.4989 15.2704C19.672 15.4435 19.7692 15.6783 19.7692 15.9231ZM19.7692 19.6154C19.7692 19.8602 19.672 20.095 19.4989 20.2681C19.3258 20.4412 19.091 20.5385 18.8462 20.5385H11.4615C11.2167 20.5385 10.9819 20.4412 10.8088 20.2681C10.6357 20.095 10.5385 19.8602 10.5385 19.6154C10.5385 19.3706 10.6357 19.1358 10.8088 18.9627C10.9819 18.7896 11.2167 18.6923 11.4615 18.6923H18.8462C19.091 18.6923 19.3258 18.7896 19.4989 18.9627C19.672 19.1358 19.7692 19.3706 19.7692 19.6154Z" fill="#323237"/>
                </svg>
            </div>
        )
    }

    return (
        <div {...props}>
            <img src={`/image/files/${extension}.svg`} onLoad={imageLoad} alt="ext" style={{width: 30}}/>
        </div>
    )
}

const Wrapper = ({description, tooltipShow, fileName, fileSize,  children}) => {
    const {i18n} = useTranslation();

    const LinkWrapper = ({styles, children}) => {
        return (
            <Tooltip placement="top" title={(fileName && tooltipShow) ? `${fileName} ${prettyBytes(fileSize, {locale: i18n.language})}` : null}>
                <div style={styles} onClick={e => e.stopPropagation()}>
                    {children}
                </div>
            </Tooltip>
        )
    }

    if (description) {
        return (
            <LinkWrapper styles={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                position: 'relative',
                height: "100%"
            }}>
                <div>{description}:</div>
                {children}
            </LinkWrapper>
        )
    }

    return <LinkWrapper styles={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        position: 'relative',
        height: "100%"
    }}>{children}</LinkWrapper>
}

const isImage = (extensions) => {
    if (!extensions) {
        return false;
    }

    return ["png", "jpg", "svg", "webp" , "jpeg"].some(ext => extensions.includes(ext))
}

export default function File({showDescription, canBeLink = () => {}, getSize = () => {}, tooltipShow = true, field, result, widget, file, imageLoad = () => {}}){
    const [isReady, setIsReady] = useState(false)
    const [isThumbnail, setIsThumbnail] = useState(false)
    const [isFile, setIsFile] = useState(false)
    const [fileSize, setFileSize] = useState(0);

    const findFiles = () => {
        const urlFile = getUrl()
        if(!urlFile){
            return  setIsReady(true)
        }

        fetch(urlFile, {
            method: "HEAD",
            headers: {
                'Cache-Control': 'no-cache'
            }
        })
            .then(res => {
                if (res.status !== 200) {
                    setIsReady(true)
                    return;
                }

                setFileSize(+res.headers.get('content-length'))
                getSize(+res.headers.get('content-length'))
                setIsFile(true)

                if (!widget || !widget.result?.schema?.properties[field]?.['x-path']?.thumbnail) {
                    setIsReady(true)
                    return;
                }

                const thumbnailUrl = getThumbnail();

                if(!thumbnailUrl){
                    setIsReady(true)
                    return null
                }

                fetch(getThumbnail(), {
                    method: "HEAD",
                    headers: {
                        'Cache-Control': 'no-cache'
                    }
                })
                    .then(res => {
                        if (res.status === 200) {
                            setIsReady(true)
                            setIsThumbnail(true)
                            return
                        }

                        setIsReady(true)
                        setIsThumbnail(false)
                    })
                    .catch(() => setIsReady(true))
            })
            .catch(() => setIsReady(true))
    }

    const getUrl = () => {
        if(!widget){
            return null
        }

        // const { upload_url } = widget?.result.schema.properties[field]?.['x-path']
        //
        // if(!upload_url){
        //     return null
        // }
        //
        // if(upload_url.includes("{azure_blob_storage}")){
        //     return file?.url || null
        // }
        // if(upload_url.includes("{cor_blob_storage}")){
        //     return file?.url ||  null
        // }

        return file?.url || null
    }

    const getThumbnail = () => {
        const fileUrl = file?.url;
        const [thumbnailKey] = Object.keys(widget.result.schema.properties[field]?.['x-path'].thumbnail)
        let thumbnailWidget = widget.result.schema.properties[field]?.['x-path'].thumbnail[thumbnailKey]

        if(!thumbnailWidget.pattern){
            return null
        }

        const pattern = thumbnailWidget.pattern.regexp ? new RegExp(thumbnailWidget.pattern.regexp) : thumbnailWidget.pattern.string

        return fileUrl.replace(pattern, thumbnailWidget.replacement)
    }

    const openLinkToNewTab = (e) => {
        e.preventDefault();
        e.stopPropagation();


        let url = showUrl();
        url = url.endsWith('.svs') ? MAKE_VIEWER_SVS_URI(url) : url;

        window.open(url);
    }

    const showUrl = () => {
        const ext = getUrl().split('.')[getUrl().split('.').length - 1]

        if(ext === "cor-ekg"){
            return `${VIEWER_EKG_PAGE_URI}?path=${getUrl()}`
        }

        return getUrl()
    }


    useEffect(() => {
        findFiles()
    }, [file?.url])


    if (!isReady) {
        return null
    }

    if (!isFile) {
        return (
            <Wrapper tooltipShow={tooltipShow} description={showDescription && widget && widget.result.schema.properties[field].description}>
                {(getUrl() && canBeLink) ? (
                    <a href={getUrl()} onClick={openLinkToNewTab} target={"_blank"}  style={{height: "100%"}}>
                        <img className ="widgetImg"
                             onLoad={imageLoad}
                             style={{cursor: canBeLink ? "pointer" : "auto", width: 30, height: 30}}
                             src={`/image/icon/question.svg`}
                             alt=" 1i "/>
                    </a>
                ) : (
                    <img className ="widgetImg"
                         src={`/image/icon/question.svg`}
                         style={{width: 30, height: 30}}
                         onLoad={imageLoad}
                         alt=" 2i "/>
                )}
            </Wrapper>
        )
    }

    if (widget && widget.result?.schema?.properties[field]?.['x-path']?.thumbnail && isThumbnail) {
        return (
            <Wrapper tooltipShow={tooltipShow} fileName={file.name} fileSize={fileSize}  description={showDescription && widget && widget.result.schema.properties[field].description}>
                {(getUrl() && canBeLink) ? (
                    <a href={getUrl()} onClick={openLinkToNewTab} target={"_blank"} style={{height: "100%", width: "100%"}}>
                        <img className="widgetImg"
                             style={{cursor: canBeLink ? "pointer" : "auto", width: "100%", maxWidth: 70, objectFit: "contain"}}
                             src={`${getThumbnail()}`}
                             onLoad={imageLoad}
                             alt=" 5i "/>
                    </a>
                ) : (
                    <img className="widgetImg"
                         style={{cursor: canBeLink ? "pointer" : "auto", width: "100%", maxWidth: 70, objectFit: "contain"}}
                         src={`${getThumbnail()}`}
                         onLoad={imageLoad}
                         alt=" 5i "/>
                )}
            </Wrapper>
        )
    }

    if (isFile) {
        const url = getUrl();
        const splitUrl = url.split('.')
        const ext = splitUrl[splitUrl.length - 1];
        const isImageFile = isImage(ext);

        return (
            <Wrapper tooltipShow={tooltipShow} fileName={file.name} fileSize={fileSize} description={showDescription && widget && widget.result.schema.properties[field].description}>
                {(getUrl() && canBeLink) ? (
                    <a href={getUrl()} onClick={openLinkToNewTab} target={"_blank"} style={{height: "100%"}}>
                        {isImageFile ? (
                            <img className ="widgetImg"
                                 style={{cursor: canBeLink ? "pointer" : "auto"}}
                                 src={`${getUrl()}`}
                                 onLoad={imageLoad}
                                 alt=" 3i "/>
                        ) : (
                            <FileIcon style={{fontSize: 40, marginTop: 5, cursor: "pointer"}}
                                      extension={ext} imageLoad={imageLoad}/>
                        )}
                    </a>
                ) : (
                    <>
                        {isImageFile ? (
                            <img className ="widgetImg"
                                 style={{cursor: canBeLink ? "pointer" : "auto"}}
                                 src={`${getUrl()}`}
                                 onLoad={imageLoad}
                                 alt=" 4i "/>
                        ) : (
                            <FileIcon style={{fontSize: 40, marginTop: 5, cursor: "pointer"}}
                                      extension={ext} imageLoad={imageLoad}/>
                        )}
                    </>
                )}
            </Wrapper>
        )
    }

    return null
}
